import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=59b3ce24&scoped=true&"
import script from "./magazine.vue?vue&type=script&lang=js&"
export * from "./magazine.vue?vue&type=script&lang=js&"
import style0 from "./magazine.vue?vue&type=style&index=0&id=59b3ce24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b3ce24",
  null
  
)

export default component.exports